<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar card color="white">
            <v-flex>
              <v-text-field
                flat
                hide-details
                :placeholder="$t('search')"
                prepend-icon="search"
                solo
                v-model="search"
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-menu
                v-model="menu_start"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="start_date"
                    :label="$t('startAt')"
                    prepend-icon="event"
                    readonly
                    clearable
                    @click:clear="startAt = null"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startAt"
                  @input="menu_start = false"
                  :first-day-of-week="1"
                  locale="es-ES"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex>
              <v-menu
                v-model="menu_end"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="end_date"
                    :label="$t('endAt')"
                    prepend-icon="event"
                    readonly
                    clearable
                    @click:clear="endAt = null"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endAt"
                  @input="menu_end = false"
                  :first-day-of-week="1"
                  locale="es-ES"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-btn
              v-if="can('create', 'tournament')"
              @click="newTournament()"
              color="primary"
              small
            >{{$t('new')}}</v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-progress-linear
            class="my-0"
            :active="$store.state.tournaments.loading"
            height="3"
            :indeterminate="true"
          ></v-progress-linear>
          <v-container fluid grid-list-xl>
            <v-layout row wrap>
              <v-flex lg3 sm-12 v-for="item in filteredList" :key="item._id">
                <tour-card
                  :tournament="item"
                  @access="modal = true"
                  @signup="modalInscription = true"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
      <!-- <v-flex xs12 text-xs-right>
        <v-btn @click="newTournament()" color="primary" small>{{$t('new')}}</v-btn>
      </v-flex>-->
      <tab-acceder :modal.sync="modal" @edit="modalForm = true" />
      <formManager :modal.sync="modalForm" @cancel="cancel" ref="formanager"></formManager>
      <dialog-inscription :modal.sync="modalInscription"></dialog-inscription>
    </v-layout>
  </v-container>
</template>

<script>
import formManager from './formManager'
import tourCard from './TournamentCard'
import { mapActions, mapState } from 'vuex'
import TabAcceder from '@/components/apps/tournaments/tabAcceder'
import DialogInscription from './DialogInscription'
import { dateFormat, formatDate } from '@/helpers/dateHelper'

export default {
  name: 'tournaments',
  components: {
    TabAcceder,
    formManager,
    tourCard,
    DialogInscription
  },
  data() {
    return {
      search: '',
      startAt: null,
      endAt: null,
      menu_start: false,
      menu_end: false,

      modal: false,
      modalForm: false,
      modalInscription: false,
      sendTour: {},
      show1: false,
      show2: false,
      show3: false,
      description:
        'TDBarcelona busca fomentar la comunicación en los alumnos de los dos últimos cursos de ESO y de Bachillerato.'
    }
  },
  created() {
    this.$store.commit('tournaments/updateView', true)
  },
  mounted() {
    this.initData()
  },
  beforeDestroy() {
    this.$store.commit('tournaments/updateView', false)
  },
  computed: {
    ...mapState({
      list: state => state.tournaments.list,
      statusOfButton: state => state.events.status
    }),
    start_date() {
      return formatDate(this.startAt)
    },
    end_date() {
      return formatDate(this.endAt)
    },
    filteredList() {
      let filteredList = this.list.filter(item => {
        if (!this.startAt && !this.endAt) return true

        let valid = false
        if (this.startAt) {
          valid =
            new Date(this.startAt).getTime() <= new Date(item.startAt).getTime()
        }
        if (this.endAt) {
          valid =
            valid ||
            new Date(this.endAt).getTime() >= new Date(item.endAt).getTime()
        }
        return valid
      })

      let formatedList = filteredList.map(item => {
        return {
          _id: item._id,
          name: item.name,
          startAt: dateFormat(item.startAt, false),
          endAt: dateFormat(item.endAt, false)
        }
      })

      filteredList = this.filterArray(formatedList, this.search)
      return this.list.filter(item =>
        filteredList.map(item => item._id).includes(item._id)
      )
    }
  },
  methods: {
    ...mapActions({
      setClearOne: 'tournaments/setClearOne',
      init: 'tournaments/setInit',
      initTournaments: 'tournaments/setInitSelect',
      // initMatches: "matches/setInit",
      initStadiums: 'stadiums/setInit',
      initEntities: 'entities/setInitSelect',
      initActs: 'acts/setInitSelect',
      initTeams: 'teams/setInitSelect',
      initUsers: 'users/setInitSelect',
      initAspects: 'aspects/setInit',
      setStatus: 'events/setStatus'
    }),
    newTournament() {
      this.setClearOne()
      this.modalForm = true
    },
    cancel() {
      console.log('cancel')
      this.modal = false
      this.modalForm = false
      this.modalInscription = false
      this.setClearOne()
    },
    async initData() {
      await this.init(),
        await Promise.all([
          // this.initMatches(),
          this.initStadiums(),
          this.initTournaments(),
          this.initEntities(),
          this.initActs(),
          this.initTeams(),
          this.initUsers({populateRole: true}),
          this.initAspects()
        ])
    }
  },
  watch: {
    // modalForm(val) {
    //   if (!val && !this.modal) {
    //     const vm = this
    //     setTimeout(() => {
    //       // vm.setClearOne()
    //     }, 1000);
    //   }

    // },
    // modal(val) {
    //   if (!val) {
    //     const vm = this
    //     setTimeout(() => {
    //       // vm.setClearOne()
    //     }, 1000);
    //   }
    // },
    statusOfButton: function(val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    }
  }
}
</script>

<style scoped>
.mt-45 {
  margin-top: -45px;
}

.mt-56 {
  margin-top: -56px;
}

.title-tournament {
  text-shadow: 1px 1px #000;
  color: #62c6c5;
}

.tag-inscription {
  background-color: #6273b7;
}

.tag-end {
  background-color: red;
}

.tag-completed {
  background-color: #ffc107;
}
</style>
}
